import type { Core, Schema } from "../../..";
import type { Parser } from "../parser";

import { interfaceSuffix as isf } from "../misc/constants";

export class FormFieldsParser implements Parser {
	parse(schema: Record<string, Schema.FormTemplate>, config: Core.Config) {
		const interfaceSuffix = config.autotypes?.interfaceSuffix || isf;
		const names = Object.keys(schema).map((name) => `"${name}"`);
		const namesWithProp = Object.keys(schema).map(
			(name) => `${name}${interfaceSuffix}`,
		);

		return names.length
			? `export type FormFields = ${names.join("|")}
export type FormFields${interfaceSuffix} = ${namesWithProp.join("|")}
`
			: "";
	}
}
